module.exports = __webpack_public_path__ + "img/plus-solid.7e95d89f.svg";